import React from "react";

import { SLABenefitOptions, SLACalloutOptions } from "./proposalDocuments.constants";
import { useProposalDocument } from "./proposalDocumentsContext";

const SLAContent: React.FC = () => {
  const { payload, setPayload } = useProposalDocument();

  const handleToggleSLA = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPayload({ ...payload, show_sla_content: e.target.checked });
  };

  const handleBenefitsChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPayload({
      ...payload,
      sla_benefits: e.target.value as "default",
    });
  };

  const handleCalloutChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPayload({
      ...payload,
      sla_callout: e.target.value as "default",
    });
  };

  return (
    <div className="sla-content">
      <div className="sla-content__header">
        <h2>SLA Content</h2>
        <label className="sla-content__toggle-label">
          <div className="sla-content__switch">
            <input
              type="checkbox"
              checked={payload.show_sla_content}
              onChange={handleToggleSLA}
              aria-label="Include SLA content"
            />
            <div className="toggle-track" />
            <div className="toggle-thumb" />
          </div>
          <span>{payload.show_sla_content ? "Included" : "Excluded"}</span>
        </label>
      </div>

      <div className="sla-content__content">
        {payload.show_sla_content ? (
          <div className="sla-content__options">
            <div className="sla-content__option-group">
              <label htmlFor="sla-benefits">SLA Benefits</label>
              <select
                id="sla-benefits"
                value={payload.sla_benefits}
                onChange={handleBenefitsChange}
              >
                {SLABenefitOptions.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="sla-content__option-group">
              <label htmlFor="sla-callout">SLA Callout</label>
              <select id="sla-callout" value={payload.sla_callout} onChange={handleCalloutChange}>
                {SLACalloutOptions.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        ) : (
          <div className="sla-content__empty-state">
            <p>SLA content is not included. Toggle above to enable.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SLAContent;
